var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex subscriber-avatars"},_vm._l((_vm.subscribers),function(subscriber){return _c('subscriber-avatar',{key:subscriber.id,attrs:{"x-small":"","subscriber":subscriber}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }